import { BrowserRouter, Routes, Route } from "react-router-dom";
import Footer from "./componant/Footer/Footer";
import Header from "./componant/Header/Header";
import 'bootstrap/dist/css/bootstrap.min.css';
import './Assets/css/style.css'
import './Assets/css/responsive.css'
import './Assets/css/font.css'
import Home from "./componant/Home/Home";
import Login from "./componant/Login/Login";
import Registration from "./componant/Registration/Registration";
import ForgetPassword from "./componant/Login/ForgetPassword";
import ImageGenerator from "./componant/user/ImageGenerator";
import Imagegallery from "./componant/user/ImageGallery";
import Dashboard from "./componant/user/Dashboard";
// import Subscriptions from "./componant/user/Subscriptions";
import { useDispatch, useSelector } from "react-redux";
import MainRequest from "./mainRequest";
import MyAccount from "./componant/user/MyAccount";
import Invoice from "./componant/user/my-account/Invoice";
import AboutUs from "./componant/static_pages/AboutUs";
import Pricing from "./componant/static_pages/Pricing";
import Contactus from "./componant/static_pages/ContactUs";
import Privacypolicy from "./componant/static_pages/PrivacyPolicy";
import TermsCondition from "./componant/static_pages/TermsAndConditions";
import 'react-loading-skeleton/dist/skeleton.css'
import { Faq } from "./componant/static_pages/Faq";
import ResetPassword from "./componant/Login/ResetPassword";
import Thankyou from "./componant/static_pages/Thankyou";
import Verification from "./componant/Login/varification";
import HelpCenter from "./componant/user/HelpCenter";
import Refund from "./componant/static_pages/Refund";
import './Assets/css/midjourney.css'
import About from "./componant/static_pages/About";
import Blogs from "./componant/static_pages/blogs";
import A_Designers_Guide_To_Midjourney_Free_Ai from "./componant/static_pages/blog/A_Designers_Guide_To_Midjourney_Free_Ai";
import TexttoImageAIGeneratorModule from "./componant/static_pages/blog/TexttoImageAIGeneratorModule";
import Creative_MidJourney_Free_Applications from "./componant/static_pages/blog/Creative_MidJourney_Free_Applications";
import Features_of_MidJourney_Free from "./componant/static_pages/blog/Features_of_MidJourney_Free";
import AIblogs from "./componant/static_pages/blog/AIblogs";
import CookieConsent from "react-cookie-consent";
import Disclaimer from "./componant/static_pages/Disclaimer";
import { useEffect } from "react";
import { setHomedata } from "./Reducer/homeReducer";
function App() {

  const dispatch = useDispatch();
  useEffect(() => {
    fetch("https://ipinfo.io/json")
      .then((response) => response.json())
      .then((data) => {
        // console.log(data);
        if (data.country === "US" && data.region === "California") {
          dispatch(setHomedata({isUsa : true}));
        } else {
          dispatch(setHomedata({isUsa : false}));
        }
      })
      .catch((error) => {
        console.error("Error fetching IP information:", error);
      });
  }, [dispatch]);

  function enableTracking() {
    const trackingId = "G-CJSPGZ65NW"; // Replace with your GA4 measurement ID
    window.gtag("config", trackingId, {
      anonymize_ip: true, // Optional: anonymize IP for privacy compliance
    });
  }
  return (
    <div className="App">

      <BrowserRouter>
        <Header />
        <Routes>
          <Route index element={<Home />} />
          <Route path="/login" element={<Login />} />
          {/* <Route path="/verification" element={<Verification />} /> */}
          <Route path="/registration" element={<Registration />} />
          <Route path="/password/reset" element={<ForgetPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/user/image-generator/:prompt" element={<ImageGenerator />} />
          <Route path="/user/image-generator" element={<ImageGenerator />} />
          <Route path="/user/image-gallery" element={<Imagegallery />} />
          <Route path="/user/my-account" element={<MyAccount />} />
          <Route path="/user/help-center" element={<HelpCenter />} />
          <Route path="/user/dashboard" element={<Dashboard />} />
          <Route path="/user/invoice" element={<Invoice />} />
          <Route path="/user/thank-you" element={<Thankyou />} />
          {/* <Route path="/about-us" element={<AboutUs />} /> */}
          <Route path="/about-us" element={<About />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/contact-us" element={<Contactus />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/privacy-policy" element={<Privacypolicy />} />
          <Route path="/refund-policy" element={<Refund />} />
          <Route path="/terms-condition" element={<TermsCondition />} />
          <Route path="/faq" element={<Faq />} />

          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blog/a-designers-guide-to-midjourney-free-ai" element={<A_Designers_Guide_To_Midjourney_Free_Ai />} />
          <Route path="/blog/text-to-image-ai-generator-module" element={<TexttoImageAIGeneratorModule />} />
          <Route path="/blog/5-Creative-MidJourney-Free-Applications" element={<Creative_MidJourney_Free_Applications />} />
          <Route path="/blog/7-Best-Features-of-MidJourney-Free" element={<Features_of_MidJourney_Free />} />
          <Route path="/blog/ai-demystified-exploring-the-possibilities" element={<AIblogs/>} />
        </Routes>

         <CookieConsent
  location="bottom"
  buttonText="Accept"
  cookieName="myAwesomeCookieName2"
  style={{ background: "#222" }}
  buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
  expires={150}
  onAccept={() => {
      console.log("User accepted tracking");
          enableTracking();
  }}
  enableDeclineButton
  onDecline={() => {
    console.log("User declined tracking");
  }}
>
We use cookies to improve your experience on our site. By using our site, you agree to our use of cookies.{" "}
 
</CookieConsent>
        <MainRequest />
       <Footer />

      </BrowserRouter>

    </div>
  );
}

export default App;
